import { createFileRoute } from "@tanstack/react-router";
import { VideosIndexPage } from "@/pages/videos/VideosIndexPage";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

export const Route = createFileRoute("/videos/")({
  component: VideosIndexPage,
  head() {
    const url = `${SITE_URL}/videos`;
    const title = "SAINT® TMS & Neuromodulation Videos | Neuro Wellness TMS";
    const description =
      "Watch explainer videos, patient stories, and education sessions on SAINT® TMS, Prism, and advanced neuromodulation for treatment-resistant depression and PTSD.";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: url }, ...buildHreflang("/videos")],
    };
  },
});
